import React, { useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Container,
  Button,
} from '@mui/material';
import { Logout as LogoutIcon } from '@mui/icons-material';
import { colors } from '../theme';
import { authAPI } from '../services/api';

const Header = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    authAPI.logout();
  };

  return (
    <AppBar position="sticky" sx={{ backgroundColor: '#FFFFFF', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          {/* Logo and Title */}
          <Box
            component={RouterLink}
            to="/"
            sx={{
              display: 'flex',
              alignItems: 'center',
              textDecoration: 'none',
              color: colors.royalBlue,
              flexGrow: 1,
            }}
          >
            <Box
              component="img"
              src="/logo.webp"
              alt="Lions Logo"
              sx={{ height: 40, mr: 2, display: { xs: 'none', sm: 'block' } }}
            />
            <Box>
              <Typography
                variant="h6"
                component="div"
                sx={{ fontWeight: 700, fontSize: { xs: '1rem', sm: '1.25rem' } }}
              >
                獅聲心語
              </Typography>
              <Typography
                variant="caption"
                component="div"
                sx={{ color: colors.textSecondary, fontSize: '0.7rem', lineHeight: 1 }}
              >
                國際獅子會中國港澳303區
              </Typography>
            </Box>
          </Box>

          {/* Logout */}
          <IconButton
            onClick={handleLogout}
            sx={{ color: colors.royalBlue }}
            title="登出"
          >
            <LogoutIcon />
          </IconButton>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
